import { PersonType } from "App.types";
import styles from "./ChangeLanguageModel.module.scss";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "Api";
import { FC, useContext } from "react";
import { UserContext } from "App";

const SelectPersonModal: FC<{ onSelect: () => any }> = ({ onSelect }) => {
  const { data } = useQuery({
    queryKey: ["persons"],
    queryFn: API.person.getList,
  });

  const user = useContext(UserContext);

  const client = useQueryClient();

  const setPerson = (person: PersonType) => {
    API.user
      .updateProp("PERSON", person.id)
      .then(() => client.invalidateQueries({ queryKey: ["props", user?.id] }))
      .then(onSelect);
  };

  return (
    <div className={styles.changeLanguageModel}>
      <div>Выбери персонажа:</div>

      {data?.map((person) => (
        <div key={person.id} className={styles.item} onClick={() => setPerson(person)}>
          <div className={styles.icon}>{person.avatar}</div>
          <div className={styles.title}>{person.title}</div>
          <div className={""}>{person.description}</div>
        </div>
      ))}
    </div>
  );
};

export default SelectPersonModal;
